import css from './index.module.scss';
import { useGlobal } from '@/utils/useGlobal';
import NextImage from '@/components/NextImage';

export default function R() {
    const { useLang, useRouter } = useGlobal();
    const { t } = useLang('delta2max.detail');
    const { locale } = useRouter();

    const suffix = ['cn', 'us', 'eu', 'jp'].includes(locale) ? locale : 'us';
    const IS_NA = ['us', 'ca'].includes(locale);
    const IS_ROW = ['au', 'br', 'mx', 'za', 'ph', 'sa'].includes(locale);
    const items: any[] = [
        {
            key: 1,
            title: t('sec18_desc1'),
        },
        {
            key: 2,
            title: t('sec18_desc2'),
        },
        {
            key: 5,
            title: t('sec18_desc5'),
        },
    ];

    return (
        <div
            className={`d2x-detail-R ${css.d2xDetailR} GtmModuleData-section`}
            id="d2x-detail-R"
            data-section-id={'d2x-detail-R'}
            data-section-title={t('sec18_title')}
        >
            <div className="title">{t('sec18_title')}</div>
            {IS_NA || IS_ROW ? (
                <div className="box-na">
                    {items.map((item, index) => (
                        <div className={`item item-${item.key}`} key={index} style={{ gridArea: `box-${item.key}` }}>
                            <div className="img-box">
                                <NextImage
                                    webpSrc={require(`@publicLocal/delta2max/detail/pc/sec18_${item.key}${item.key === 5 ? '_us' : ''}.webp`)}
                                    src={require(`@publicLocal/delta2max/detail/pc/sec18_${item.key}${item.key === 5 ? '_us' : ''}.png`)}
                                    alt={item.title}
                                    aria-label={item.title}
                                />
                            </div>
                            <div className="item-title">{item.title}</div>
                        </div>
                    ))}
                </div>
            ) : (
                <div className="flex-box">
                    <div className="card card1">
                        <div className="img-box">
                            <NextImage
                                webpSrc={require('@publicLocal/delta2max/detail/pc/sec18_1.webp')}
                                src={require('@publicLocal/delta2max/detail/pc/sec18_1.png')}
                            />
                        </div>
                        <div className="title">{t('sec18_desc1')}</div>
                    </div>
                    <div className="right">
                        <div className="card card2">
                            <div className="img-box">
                                <NextImage
                                    webpSrc={require('@publicLocal/delta2max/detail/pc/sec18_2.webp')}
                                    src={require('@publicLocal/delta2max/detail/pc/sec18_2.png')}
                                />
                            </div>
                            <div className="title">{t('sec18_desc2')}</div>
                        </div>
                        <div className="card card3">
                            <div className="img-box">
                                <NextImage
                                    webpSrc={require('@publicLocal/delta2max/detail/pc/sec18_3.webp')}
                                    src={require('@publicLocal/delta2max/detail/pc/sec18_3.png')}
                                />
                            </div>
                            <div className="title">{t('sec18_desc3')}</div>
                        </div>
                        <div className="card card4">
                            <div className="img-box">
                                <NextImage
                                    webpSrc={require('@publicLocal/delta2max/detail/pc/sec18_4.webp')}
                                    src={require('@publicLocal/delta2max/detail/pc/sec18_4.png')}
                                />
                            </div>
                            <div className="title">{t('sec18_desc4')}</div>
                        </div>
                        <div className="card card5">
                            <div className="img-box">
                                <NextImage
                                    webpSrc={require(`@publicLocal/delta2max/detail/pc/sec18_5_${suffix}.png`)}
                                    src={require(`@publicLocal/delta2max/detail/pc/sec18_5_${suffix}.png`)}
                                />
                            </div>
                            <div className="title">{t('sec18_desc5')}</div>
                        </div>
                    </div>
                </div>
            )}
        </div>
    );
}
